<template>
  <div class="mw-panel">
    <div class="mw-tree-search" v-if="search">
      <el-input
        :placeholder="$lang('请输入搜索内容')"
        v-model="searchText"
        clearable>
      </el-input>
    </div>
    <div :class="{'mw-tree-search__body':search,'mw-tree-no-search__body':!search}">
      <div class="mw-tree">

      </div>
    </div>
  </div>
</template>
<script>
  export default {

    name: 'MwLiTree',
    props: {
      search:{
        type: Boolean,
        default: false
      },
      //是否自动加载
      autoLoad:{
        type: Boolean,
        default: true
      },
      //默认的根节点条件
      defaultParentId:{
        type: String
      },
      //默认参数
      defaultParams:{
        type: Object
      },
      //加载数据地址
      url: {
        type: String
      },
      //是否打开第一个节点
      expandedFirst: {
        type: Boolean,
        default: false
      },
      //是否异步加载
      async: {
        type: Boolean,
        default: false
      },
      //是否多选
      multiple: {
        type: Boolean,
        default: false
      },
      singleLeaf: {
        type: Boolean,
        default: false
      },
      //多选是否只选最子节点
      multipleLeaf: {
        type: Boolean,
        default: false
      },
      contextMenuItem: {
        type: Array,
        default: function () {
          return [];
        }
      },
      //多选时选中的ID
      checkNodes: {
        type: Array,
        default: function () {
          return [];
        }
      },
      //单选选中ID
      selectNode: {
        type: String,
        default: ''
      },
      // 静态数据
      treeData: {
        type: [Array,Object]
      },
      isDblClickDeleteNode:{
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        searchFlag:false,
        searchText:'',
        selectData: {},
        selectParents: [],

        dblClick:false,
        select:false,
        deselect:false,
        check:false
      }
    },
    watch: {
      searchText(val){
        let tree=$(this.$el.querySelector('.mw-tree')).jstree(true)
        if(val==''){
          setTimeout(function() {
            tree.clear_search()
          }, 250);
        }else{
          if (this.searchFlag) {
            clearTimeout(this.searchFlag)
          }
          this.searchFlag = setTimeout(function() {
            tree.search(val,true,true)
          }, 250);
        }
      },
      url(val){
        let tree=$(this.$el.querySelector('.mw-tree')).jstree(true);
        if(tree){
          tree.destroy();
        }
        this.renderTree();
      },
      checkNodes(newIds) {
        let me = this;
        let inst = $(this.$el.querySelector('.mw-tree')).jstree(true);
        inst.uncheck_all();
        newIds.forEach(id => {
          let obj = inst.get_node(id);
          inst.check_node(obj);
        })
      },
      selectNode(newId) {
        let me = this;
        let inst = $(this.$el.querySelector('.mw-tree')).jstree(true);
        inst.deselect_all();
        if(newId) {
          let obj = inst.get_node(newId);
          inst.select_node(obj);
        }
      }
    },
    mounted() {
      if(this.autoLoad){
        this.renderTree();
      }
    },
    destroyed() {
      let tree=$(this.$el.querySelector('.mw-tree')).jstree(true);
      if(tree){
        tree.destroy();
      }
    },
    methods: {
      getInstance(){
        let me=this;
        return $(me.$el.querySelector('.mw-tree')).jstree(true);
      },
      showNode(id){
        let me=this;
        let obj= $(me.$el.querySelector('.mw-tree')).jstree(true).get_node(id);
        $(me.$el.querySelector('.mw-tree')).jstree(true).show_node(obj);
      },
      getSelectNodes(){
         let tree = $(this.$el.querySelector('.mw-tree')).jstree(true);
         let selected = tree.get_selected();
         let data=[];
         if (selected.length > 0) {
           selected.forEach(id => {
             var obj=tree.get_node(id);
             if(!obj.state.hidden){
               //tree.hide_node(obj);
               var d=Object.assign({parentId:obj.parent},obj.original);
               data.push(d);
             }
           });
         }
         return data;
      },
      checkAll() { //全选
        let inst = $(this.$el.querySelector('.mw-tree')).jstree(true);
        inst.select_all();
      },
      unCheckAll() {//取消全选
        let inst = $(this.$el.querySelector('.mw-tree')).jstree(true);
        inst.deselect_all();
      },
      openAll() { //展开
        $(this.$el.querySelector('.mw-tree')).jstree('open_all');
      },
      closeAll() { //折叠
        $(this.$el.querySelector('.mw-tree')).jstree('close_all');
      },
      refresh() { //刷新url重新加载
        $(this.$el.querySelector('.mw-tree')).jstree(true).refresh();
      },
      refreshData(data){ //刷新 静态数据加载
        if(!$(this.$el.querySelector('.mw-tree')).jstree(true)){
          this.renderTree();
        }else{
          if(data){
            this.$emit("beforeDataFilter",data);
          }
          $(this.$el.querySelector('.mw-tree')).jstree(true).settings.core.data = data;
          $(this.$el.querySelector('.mw-tree')).jstree(true).refresh();
        }
      },
      renderTree() { //渲染树
        let me = this, jsTreeEl = $(me.$el.querySelector('.mw-tree'));

        let plugin = ["types"];
        let items = {};
        if (me.multiple) {
          plugin.push("checkbox");
          plugin.push("wholerow");
        } else {
          plugin.push("wholerow");
        }
        if(me.search){
          plugin.push("search");
        }
        if(me.contextMenuItem.length > 0) {
          plugin.push("contextmenu");
          me.contextMenuItem.forEach(item => {
            items[item.name] = {
              "name": item.name ? item.name : '',
              "label": item.label,
              "icon": item.icon ? item.icon : '',
              "action": function (a) {
                item.func(me.selectData, me.selectParents);
              }
            }
          });
        }
        let data = {};
        if(me.treeData) {
          data = me.treeData
          me.$emit("beforeDataFilter",data);
        }

        jsTreeEl.data('jstree', false).empty();
        jsTreeEl.bind("load_node.jstree", function (e, data) {

        }).on("changed.jstree", function (e, data) {

        }).bind("loaded.jstree", function (e, data) {

        }).bind("click.jstree", function(e) {

        }).bind("dblclick.jstree", function(e) { //双击节点
            var id = e.target.id.substr(0,e.target.id.lastIndexOf('_'));
            var obj = jsTreeEl.jstree(true).get_node(id);
            me.dblClick=true;
            if (obj) {
                if(me.isDblClickDeleteNode)
                jsTreeEl.jstree(true).delete_node(obj);
                me.$emit("dblClick", obj.original, jsTreeEl);
            }
            me.dblClick=false;
        }).bind("check_node.jstree", function(e, data) {

        }).bind("select_node.jstree", function(e, data) {

        }).bind("deselect_node.jstree", function(e, data) {

        }).jstree({
          'async': me.async, //url 是一次性加载，还是异步
          'expanded_first': false,//是否已经展开树节点
          'core': {
            "themes": {
              "responsive": false
            },
            "multiple": me.multiple,  //不允许多选
            "check_callback": function (operation, node, node_parent, node_position, more) {
              return true;
            },
            'data': data
          },
          'checkbox': {
            "keep_selected_style": false,
            "three_state": true,
            "visible": true,
            "tie_selection":true
          },
          "plugins": plugin,
          "contextmenu": {
            "items": items
          },
          "types": {
            "#": {
              "icon": "fa fa-folder"
            },
            "file": {
              "icon": "fa fa-leaf"
            },
            "default": {
              "icon": "fa fa-leaf"
            }
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/common/components/public-dialog/tree/li.vue